import angular from '../assets/svgSkills/angular.svg'
import apollo from '../assets/svgSkills/apollo.svg'
import css from '../assets/svgSkills/css.svg'
import git from '../assets/svgSkills/git.svg'
import html from '../assets/svgSkills/html.svg'
import javaScript from '../assets/svgSkills/javaScript.svg'
import jest from '../assets/svgSkills/jest.svg'
import postman from '../assets/svgSkills/postman.svg'
import react from '../assets/svgSkills/react.svg'
import reactQuery from '../assets/svgSkills/reactQuery.svg'
import reduxSaga from '../assets/svgSkills/reduxSaga.svg'
import reduxToolkit from '../assets/svgSkills/reduxToolkit.svg'
import restAPI from '../assets/svgSkills/restAPI.svg'
import storyBook from '../assets/svgSkills/storyBook.svg'
import swagger from '../assets/svgSkills/swagger.svg'
import typeScript from '../assets/svgSkills/typeScript.svg'
import unitTest from '../assets/svgSkills/unitTest.svg'

export  const svgSkills = {
    angular,
    apollo,
    css,
    git,
    html,
    javaScript,
    jest,
    postman,
    react,
    reactQuery,
    reduxSaga,
    reduxToolkit,
    restAPI,
    storyBook,
    swagger,
    typeScript,
    unitTest
}